export interface SportSectionEntry {
    [name: string]: string
}

// used for displaying the Name of the Section
export const sections: SportSectionEntry = {
    baseball: 'Baseball',
    basketball: 'Basketball',
    soccer: 'Fußball',
    handball: 'Handball',
    judo: 'Judo',
    jujutsu: 'JuJutsu',
    karate: 'Karate',
    athletics: 'Leichtathletik',
    chess: 'Schach',
    swimming: 'Schwimmen',
    dancing: 'Tanzsport',
    tableTennis: 'Tischtennis',
    theatre: 'Theater/Laienspiel',
    volleyball: 'Volleyball',
    adyton: 'Adyton',
    tennis: 'Tennis',
    freeAthletics:
        'Turnen, Freizeit- und Gesundheitssport (z.B. Kinderturnen für Kinder über 4 Jahre, Seniorensport, BBP)',
    badminton: 'Badminton',
    kungfu: 'Kung-Fu',
    lungSport: 'Lungensport ohne Verordnung',
    krebsSport: 'Krebssport ohne Verordnung',
    osteoporose: 'Osteoporose',
    backFit: 'Rückenfit',
    trampoline: 'Trampolin',
    sportgymnastik: 'Rhythmische Sportgymnastik',
    yoga: 'Yoga',
    childAthletics: 'Kinderturnen',
    onewheel: 'Einrad',
    hockey: 'Hockey',
    danceAddon_ballett: 'Ballett',
    danceAddon_bellydance: 'Bauchtanz',
    danceAddon_breakdance: 'Breakdance',
    danceAddon_cheerleading: 'Cheerleading',
    danceAddon_hiphop: 'Hip Hop',
    danceAddon_contemporary: 'Jazz/Modern/Contemporary',
    danceAddon_creativeChildrendance: 'kreativer Kindertanz',
    danceAddon_linedance: 'Linedance',
    danceAddon_pairdance: 'Paartanz',
    danceAddon_tapdance: 'Stepptanz',
}

// used for converting from section name to dance addon type
export const danceTypes: SportSectionEntry = {
    Ballett: 'danceAddon_ballett',
    Bauchtanz: 'danceAddon_bellydance',
    Breakdance: 'danceAddon_breakdance',
    Cheerleading: 'danceAddon_cheerleading',
    'Hip Hop': 'danceAddon_hiphop',
    'Jazz/Modern/Contemporary': 'danceAddon_contemporary',
    'kreativer Kindertanz': 'danceAddon_creativeChildrendance',
    'Line Dance': 'danceAddon_linedance',
    Paartanz: 'danceAddon_pairdance',
    Stepptanz: 'danceAddon_tapdance',
}
